import Handle504Message from "./504Message"
import MessageComponent from "./MessageComponent"


export default Handle504Message;
export {
    MessageComponent
}